module.exports = __webpack_public_path__ + "static/media/nc.e1238c4a.svg";